var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_play") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "24_Specific-player---matches---full-video",
    transform: "translate(-631, -779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path",
    transform: "translate(631, 779)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0635502,8.85360207 L2.26038231,0.272464764 C1.82722118,-0.0415715664 1.25219505,-0.0888661945 0.777420191,0.155174086 C0.298862263,0.397322582 2.29150032e-13,0.889186713 2.29150032e-13,1.42077833 L2.29150032e-13,18.5773776 C2.29150032e-13,19.1146446 0.298862263,19.6046169 0.777420191,19.8467654 C0.979814255,19.9489218 1.20112365,20 1.42432458,20 C1.71562071,20 2.01069991,19.9073025 2.26038231,19.7237994 L16.0635502,11.1502292 C16.4361822,10.8759204 16.6537205,10.4521605 16.6537205,10.0019156 C16.6556001,9.54410364 16.4323992,9.12223556 16.0635502,8.85360207 Z",
    fill: "#040802",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlay);
export default __webpack_public_path__ + "static/media/ic_play.b3889a47931401d9f5644ed3f0b28b47.svg";
export { ForwardRef as ReactComponent };